import Unstructured from './Unstructured.js';
import DataHelper from '../../helpers/DataHelper.js';

export default class VehicleFinanceCalculator extends Unstructured {

  trackInteraction(data) {
    this._pushEventData(DataHelper.filterDeeply(data));
    this.send();
  }

  get version() {
    return '1-2-0';
  }

  _pushEventData(data) {
    super._pushEventData({
      schema: 'iglu:uk.co.netdirector.snowplow/vehicle_finance_calculator_unstructured_event/jsonschema/' + this.version,
      data: data
    });
  }
}
